import React from "react";

import { SectionRetryButton } from "../../../../components/SectionRetryButton";
import { SectionNotice } from "../../styles";
import { RefreshFailedNoticeProps } from "./types";

export const RefreshFailedNotice: React.FC<RefreshFailedNoticeProps> = ({
  sectionName,
  onRetry,
}) => (
  <SectionNotice role="alert" data-testid="admin-refresh-failed">
    <span>{sectionName} refresh failed. Showing the last loaded data.</span>
    <SectionRetryButton onClick={onRetry} />
  </SectionNotice>
);
